// import EdCodeEditor from './src/Codemirror'
import EdCodeEditor from './src/AceEditor'

EdCodeEditor.install = function (Vue) {
  Vue.component(EdCodeEditor.name, EdCodeEditor)
}

export default EdCodeEditor
